export const baseUrl = 'https://cerameson-api.evolve-brands.co/api/v1/' //production url new
export const av = "1.0";
export const pt = "WEBSITE";
export const company = "1"
export const program = "1"


